import { HTTP_STATUS, isApiError } from '@brightlocal/api-client';

import { LOCATION_ERROR_TYPES } from '../consts';

/**
 * Classifies a failed single-location request by HTTP status: 403 is a location the user cannot
 * open, 404 a location that does not exist. Anything else — including non-API errors — is unknown.
 * @param error - The error thrown by `locationQuery`.
 */
export const classifyLocationError = (error: unknown) => {
  if (!isApiError(error)) {
    return LOCATION_ERROR_TYPES.UNKNOWN;
  }

  switch (error.status) {
    case HTTP_STATUS.FORBIDDEN:
      return LOCATION_ERROR_TYPES.FORBIDDEN;
    case HTTP_STATUS.NOT_FOUND:
      return LOCATION_ERROR_TYPES.NOT_FOUND;
    default:
      return LOCATION_ERROR_TYPES.UNKNOWN;
  }
};
